/**
 * Get the friendly name of an event type.
 * It can either come from a customization or directly from Keyprod code.
 */
export function getEventTypeFriendlyName(eventType, locale = 'fr') {
  if (!!eventType && eventType?.name) return eventType.name;
  if (!eventType || !locale || !eventType.names || !eventType.names[locale]) return '';

  return eventType.names[locale];
}

export default getEventTypeFriendlyName;
